// extracted by mini-css-extract-plugin
export default {"wrap":"EditGpaPopup_wrap__iKkhh","title":"EditGpaPopup_title__QcZpw","submitContainer":"EditGpaPopup_submitContainer__uIMO6","sapDateTitle":"EditGpaPopup_sapDateTitle__kBRiA"};